import { useSelector } from 'react-redux';
import { getAccountDevices } from '../selectors/devices';

const useAccountDevices = () => {
	return useSelector(getAccountDevices);
}

export default useAccountDevices;